import { render, staticRenderFns } from "./GenderChart.vue?vue&type=template&id=cd5ad7be&"
import script from "./GenderChart.vue?vue&type=script&lang=js&"
export * from "./GenderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports